<template>
  <split-panel-page :showRight="false" class="releases">
    <content-nav-bar>
      <h5 class="is-size-4 level-item">Create Release</h5>
      <a v-on:click="submit()" class="add button level-item">
        <i class="far fa-save"></i>
        Save
      </a>
      <loader class="level-item" :showLoader="showLoader">Creating Release</loader>
    </content-nav-bar>
    <div class="field release-form">
      <form-field icon="circle" title="Build">
        <multiselect
          v-model="build"
          label="id"
          :options="builds"
          :show-labels="false"
          :close-on-select="true"
          :clear-on-select="true"
          :hide-selected="false"
          :allow-empty="false"
          :preselect-first="true">
        </multiselect>
      </form-field>
    </div>
  </split-panel-page>
</template>

<script>
import ContentNavBar from '@/components/ContentNavBar.vue';
import Loader from '@/components/Loader.vue';
import SplitPanelPage from '@/components/SplitPanelPage.vue';
import FormField from '@/components/forms/FormField.vue';
import Multiselect from 'vue-multiselect';

export default {
  name: 'ReleaseCreate',
  components: {
    SplitPanelPage,
    ContentNavBar,
    Loader,
    FormField,
    Multiselect,
  },
  async mounted() {
    const builds = await this.$store.dispatch('admin/listBuilds');
    this.builds = builds.items;
  },
  computed: {
    payload() {
      return {
        build: this.build ? this.build.id : null,
      };
    },
  },
  methods: {
    async submit() {
      this.showLoader = true;
      const release = await this.$store.dispatch('admin/createRelease', this.payload);
      this.showLoader = false;
      if (release) {
        this.$router.push({
          name: 'admin.releases.index.detail',
          params: { id: release.uuid },
        });
      }
    },
  },
  data() {
    return {
      showLoader: false,
      build: null,
      builds: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.release-form {
  padding: $content-padding;
}

.releases {
  .gp-content {
    height: 100%;
  }
}
</style>
